
import { Frame as FrameCore } from '@studiometa/ui';
import FrameAnchor from './FrameAnchor.js';

/**
 * Facets component
 */
export default class Frame extends FrameCore {
  /**
   * Component Configuration
   */
  static config = {
    name: 'Frame',
    components: {
      ...FrameCore.config.components,
      FrameAnchor,
    }
  };
}
